import { Button, LinearProgress } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useRouter } from "next/router";

type Props = {
  onClose: () => void;
  articleChoice: string;
  isOneClick: boolean;

  //   isRedirect?: boolean;
};

const Success = ({ onClose, articleChoice, isOneClick }: Props) => {
  const router = useRouter();

  return (
    <>
      <Box
        sx={{
          // p: 3,
          // pt: 4,
          pt: "10px !important",
          pr: "8px !important",
          textAlign: "center",
          width: "464px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            pt: "0px !important",
            // width: "100%",
          }}
        >
          <Typography
            width="19.267px"
            height="19.267px"
            flexShrink="0"
            sx={{
              cursor: "pointer",
            }}
            onClick={() => onClose()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M2.69203 15.6063L8.66481 9.6335L2.69203 3.66072C2.46324 3.43568 2.33378 3.12787 2.33228 2.80725C2.33153 2.48588 2.45872 2.17807 2.686 1.95077C2.91329 1.72423 3.2211 1.59705 3.54248 1.59855C3.86385 1.60006 4.17091 1.72951 4.39595 1.95906L10.3664 7.93183L16.3392 1.95906C16.5642 1.72951 16.8713 1.60006 17.1927 1.59855C17.5133 1.59705 17.8218 1.72424 18.0491 1.95077C18.2764 2.17807 18.4036 2.48588 18.4021 2.80725C18.4014 3.12787 18.2719 3.43568 18.0431 3.66072L12.068 9.6335L18.0408 15.6063C18.2696 15.8313 18.399 16.1391 18.4005 16.4597C18.4013 16.7811 18.2741 17.0889 18.0468 17.3162C17.8195 17.5428 17.5117 17.6699 17.1903 17.6684C16.869 17.6669 16.5619 17.5375 16.3369 17.3079L10.3664 11.3352L4.39364 17.3079C3.9225 17.7723 3.16537 17.7693 2.69723 17.3027C2.22986 16.8353 2.2261 16.0782 2.68971 15.6063L2.69203 15.6063Z"
                fill="#7B85AD"
              />
            </svg>
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          padding: "0px 22px 0px 0px",
          textAlign: "center",
          width: "464px",
          height: "490px",
        }}
      >
        <Typography
          align="left"
          gutterBottom
          color="#121828"
          /* Heading/H1 */
          fontFamily="Inter"
          fontSize="20px"
          fontStyle="normal"
          fontWeight="500"
          lineHeight="normal"
        >
          {articleChoice === "write"
            ? isOneClick
              ? "We’re preparing your article."
              : "We’re preparing the brief for you."
            : "We’re updating your article."}
        </Typography>
        <Typography
          align="left"
          fontFamily="Inter"
          fontSize="14px"
          fontStyle="normal"
          fontWeight="400"
          color="#7B85AD"
          sx={{ mt: 2 }}
        >
          {articleChoice === "write"
            ? isOneClick
              ? "Generating the article will take up to 15 minutes. While you wait, watch the video below where we explain how we’re creating your article to get the best quality."
              : "Creating the brief will take a few minutes. While you wait, learn how to write AI articles with SEOwind to perfectly match search intent!"
            : "Updating the article will take up to 15 minutes. In the meantime, check out the video below to see how we're enhancing your content for top-notch quality."}
        </Typography>
        <LinearProgress sx={{ mt: 3 }} />
        <Box sx={{ mt: 3 }}>
          <iframe
            style={{ aspectRatio: " 16 / 9", width: "100%" }}
            id="ytplayer"
            height="auto"
            src={`https://www.youtube.com/embed/${
              articleChoice === "write"
                ? isOneClick
                  ? "fsnvzzhSmZQ"
                  : "yX3IoJTcihQ"
                : "IvJjPIOzj5Q"
            }`}
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "right",
            pt: "12px",
            pb: "15px",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              onClose();
            }}
            sx={{
              borderRadius: "8px",
              width: "100px",
              height: "40px",
              textTransform: "none",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "20px",
              letterSpacing: "0.25px",
            }}
          >
            Finish
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default Success;
